import { useCallback } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

const ButtonActions = ({ mode, setMode, onSubmit, onClickCancel }) => {
    const { unregister, handleSubmit, getValues, clearErrors } = useFormContext();

    const cleanupDocks = useCallback(() => {
        const docks = getValues("docks") || [];
        if (docks.length > 0) {
            unregister([
                "dockForm",
                "dockForm.dockName",
                "dockForm.streetNo",
                "dockForm.streetName",
                "dockForm.city",
                "dockForm.province",
                "dockForm.country",
                "dockForm.postalCode",
            ]);
            clearErrors([
                "docks",
                "dockForm.dockName",
                "dockForm.streetNo",
                "dockForm.streetName",
                "dockForm.city",
                "dockForm.province",
                "dockForm.country",
                "dockForm.postalCode",
            ]);
        }
    }, [getValues, unregister, clearErrors]);

    return (
        <Row className="d-flex justify-content-end">
            {mode === "VIEW" ?
                <>
                    <Col xs="auto pe-0" md={1}> <Button onClick={() => setMode("EDIT")}>Edit</Button></Col>
                    <Col xs="auto" md={1}>  <Button onClick={onClickCancel} variant="outline-primary h-100 w-100">Cancel</Button></Col>
                </>
                :
                mode === "EDIT" ?
                    <>
                        <Col xs="auto pe-0" md={1}> <Button onClick={() => {
                            cleanupDocks();
                            handleSubmit(onSubmit)();
                        }}>Save</Button></Col>
                        <Col xs="auto" md={1}><Button variant="outline-primary" onClick={onClickCancel}>Cancel</Button></Col>
                    </>
                    :
                    <Col xs="auto">
                        <Button
                            variant="danger"
                            onClick={() => {
                                cleanupDocks();
                                handleSubmit(onSubmit)();
                            }}
                        >
                            Add Company Profile
                        </Button>
                    </Col>
            }
        </Row>
    )
}

export default ButtonActions;